import api from "../lib/utils/apiConfig";

/**
 * Get all contact submissions
 */
export const getContacts = async (search) => {
  const response = await api.get("/contact", { params: { search } });
  return response.data;
};

export const getLeadMasters = async () => {
  try {
    const response = await api.get("/contact/masters");
    return response.data;
  } catch (error) {
    const [leadStatuses, leadStages, salesStages] = await Promise.all([
      api.get("/masters/lead-status"),
      api.get("/masters/lead-stage"),
      api.get("/masters/sales-stage"),
    ]);

    return {
      success: true,
      data: {
        leadStatuses: leadStatuses.data || [],
        leadStages: leadStages.data || [],
        salesStages: salesStages.data || [],
      },
    };
  }
};

export const updateContact = async (id, data) => {
  const response = await api.put(`/contact/${id}`, data);
  return response.data;
};

/**
 * Delete a contact submission
 */
export const deleteContact = async (id) => {
  const response = await api.delete(`/contact/${id}`);
  return response.data;
};
